import { render, staticRenderFns } from "./Err.vue?vue&type=template&id=6dc8733b&scoped=true&"
import script from "./Err.vue?vue&type=script&lang=js&"
export * from "./Err.vue?vue&type=script&lang=js&"
import style0 from "./Err.vue?vue&type=style&index=0&id=6dc8733b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc8733b",
  null
  
)

export default component.exports